import memoize from 'lodash.memoize';
const getBrowserFeatureImpl = ()=>({
        virtualKeyboard: 'navigator' in globalThis && 'virtualKeyboard' in globalThis.navigator ? globalThis.navigator.virtualKeyboard : undefined
    });
const createGetBrowserFeature = ()=>{
    return memoize(getBrowserFeatureImpl);
};
/**
 * Returns an object containing the presence of various browser features.
 * The result is memoized to improve performance.
 *
 * @returns {BrowserFeature} An object with a record of features and boolean values indicating the presence of specific browser features.
 * @example
 * {
 *   virtualKeyboard: true
 * }
 */ export const getBrowserFeature = createGetBrowserFeature();

//# sourceMappingURL=getBrowserFeature.js.map